import { c as _c } from "react/compiler-runtime";
import { cn } from "cn";
interface EmptyStateProps {
  actions?: React.ReactNode;
  className?: string;
  description: string;
  icon: React.ReactNode;
  title: string;
}
export function EmptyState(t0) {
  const $ = _c(18);
  const {
    icon,
    title,
    description,
    actions,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("flex w-full max-w-xs flex-col items-center justify-center gap-3", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== icon) {
    t2 = <div className="flex size-10 items-center justify-center rounded-xl bg-surface shadow-raised [&_svg]:size-5 [&_svg]:text-fg">{icon}</div>;
    $[2] = icon;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== title) {
    t3 = <h2 className="font-medium text-2xl text-fg">{title}</h2>;
    $[4] = title;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== description) {
    t4 = <p className="text-center text-fg-muted">{description}</p>;
    $[6] = description;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <div className="flex flex-col items-center justify-center gap-1">{t3}{t4}</div>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== actions) {
    t6 = actions && <div className="mt-2 flex w-full gap-2">{actions}</div>;
    $[11] = actions;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t1 || $[14] !== t2 || $[15] !== t5 || $[16] !== t6) {
    t7 = <div className={t1}>{t2}{t5}{t6}</div>;
    $[13] = t1;
    $[14] = t2;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
}